import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - executive-force-ai-453011 (unified across all Executive Force AI apps)
// This matches the landing page config for unified SSO
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDzSVcepxdliuW-nM026lRmopvg324Q-XY",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "executive-force-ai-453011.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "executive-force-ai-453011",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "executive-force-ai-453011.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "327026071945",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:327026071945:web:17e73a735d4ac4cc25a958",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || undefined,
};

// Log Firebase config status (without exposing sensitive data)
console.log('🔥 Firebase Config Status:', {
  apiKey: firebaseConfig.apiKey ? '✅ Set' : '❌ Missing',
  authDomain: firebaseConfig.authDomain ? '✅ Set' : '❌ Missing',
  projectId: firebaseConfig.projectId ? '✅ Set' : '❌ Missing',
  storageBucket: firebaseConfig.storageBucket ? '✅ Set' : '❌ Missing',
  messagingSenderId: firebaseConfig.messagingSenderId ? '✅ Set' : '❌ Missing',
  appId: firebaseConfig.appId ? '✅ Set' : '❌ Missing',
});

// Check if any required fields are missing (measurementId is optional)
const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingFields = requiredFields.filter(key => {
  const value = firebaseConfig[key as keyof typeof firebaseConfig];
  return !value || (typeof value === 'string' && value.startsWith('YOUR_'));
});

if (missingFields.length > 0) {
  console.error('❌ Firebase config missing required fields:', missingFields);
  console.error('Please check your .env file has all VITE_FIREBASE_* variables');
}

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('✅ Firebase app initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
  throw error;
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
